"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const valueIsNumber = ((value) => {
    if (typeof value !== 'number') {
        return false;
    }
    if (Number.isNaN(value)) {
        return false;
    }
    return true;
});
exports.default = valueIsNumber;
